export default __webpack_public_path__ + "src/public/shapefiles/cb_2018_us_state_5m.zip";